import { GraphTileType } from '@/api/rest/resources/types/widget';

export const INDICATOR_COLORS_MAP = {
  [GraphTileType.historic_below_ground_carbon]: {
    dark: 'rgba(178, 141, 89, 1)',
    light: 'rgba(255, 201, 0, 1)',
  },
  [GraphTileType.historic_above_ground_carbon]: {
    dark: 'rgba(255, 221, 95, 1)',
    light: 'rgba(255, 237, 172, 1)',
  },
  [GraphTileType.historic_water_soil_moisture]: {
    dark: 'rgba(179, 242, 255, 1)',
    light: 'rgba(106, 205, 225, 1)',
  },
  [GraphTileType.protected_on_farm_habitat]: {
    dark: 'rgba(194, 249, 109, 1)',
    light: 'rgba(240, 255, 216, 1)',
  },
  [GraphTileType.social_life_expectancy]: {
    dark: 'rgba(175, 82, 222, 1)',
    light: 'rgba(221, 154, 255, 1)',
  },
  [GraphTileType.ndvi]: {
    dark: 'rgba(64, 191, 148, 1)',
    light: 'rgba(1, 255, 169, 1)',
  },
  [GraphTileType.historic_habitat_intactness]: {
    dark: 'rgba(169, 189, 137, 1)',
    light: 'rgb(183, 202, 151)',
  },
  [GraphTileType.historic_habitat_intactness_threats_breakdown]: {
    dark: 'rgba(169, 189, 137, 1)',
    light: 'rgb(183, 202, 151)',
  },
  [GraphTileType.historic_deforestation]: {
    dark: 'rgb(155, 93, 1)',
    light: 'rgb(230, 140, 7)',
  },
} as const;

export const getAggregationGraphColor = (indicator: GraphTileType) => {
  return INDICATOR_COLORS_MAP?.[indicator as keyof typeof INDICATOR_COLORS_MAP];
};
